<script>
    export default {
        props: {
            label: {
                type: String,
                default: 'auto',
            },
            name: {
                type: String,
            },
            prefill: {
                type: [String, Number],
                default: null,
            },
            options: {
                type: Array,
                default: () => [],
            },
            size: {
                type: Number,
                default: 3,
            },
            addEmpty:  {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                value: '',
                optionsIntern: this.options,
            }
        },

        watch: {
            value(value) {
                this.$emit('sync', value)
                this.$children[0].updateValue(value)
            },
            options(value) {
                this.optionsIntern = value
            },
            prefill(value) {
                this.value = value
            },
        },

        mounted() {
            this.value = this.prefill
        },

        methods: {
            appendTo(content) {
                if (this.value !== null) {
                    content[this.name] = this.value
                    content['__' + this.name] = this.optionsIntern.find(option => {
                        return (option.Id == this.value)
                    })
                }
                return content
            },
        },
    }
</script>

<template>
    <bg-form-wrapper :label="label" :name="name" :size="size" :prefill="prefill">
        <select2 class="collection-select collection-select--inline"
                 name="CountryIso"
                 @update="selected => value = selected"
                 :value="value"
                 :data="options"/>
    </bg-form-wrapper>
</template>
